// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"ActivitiesListHeader-tableHeader-Rma_9fNaVt spacing-paddingBottom-eFdNVAqjc5"};